export default "__VITE_ASSET__Uee6vKdb__"